import { inheritsLoose as _inheritsLoose } from './_virtual/_rollupPluginBabelHelpers.js';
import PropertyList from './PropertyList/index.js';
import { FormBlockBackgroundType } from './CompoundedProperties/BlockBackgroundType.js';
import { FormBlockShadowStyle } from './CompoundedProperties/BlockShadowStyle.js';
import { FormPageBackgroundType } from './CompoundedProperties/PageBackgroundType.js';
import { FormPageContrastColor } from './CompoundedProperties/PageContrastColor.js';
import { FormBlockBackgroundValue } from './Properties/BlockBackgroundValue.js';
import { FormBlockContrastColor } from './CompoundedProperties/BlockContrastColor.js';
import { FormBlockBorderRadius } from './Properties/BlockBorderRadius.js';
import { FormBlockBorderStyle } from './Properties/BlockBorderStyle.js';
import { FormBlockBorderType } from './Properties/BlockBorderType.js';
import { FormBlockBorderValue } from './Properties/BlockBorderValue.js';
import { FormBlockBorderWidth } from './Properties/BlockBorderWidth.js';
import { FormBlockShadowType } from './Properties/BlockShadowType.js';
import { FormBlockShadowValue } from './Properties/BlockShadowValue.js';
import { FormPageBackgroundValue } from './Properties/PageBackgroundValue.js';
import { FormPageFontBody } from './Properties/PageFontBody.js';
import { FormPageFontHeading } from './Properties/PageFontHeading.js';
import { FormPageButtonContrastColor } from './CompoundedProperties/PageButtonContrastColor.js';
import { FormBlockButtonContrastColor } from './CompoundedProperties/BlockButtonContrastColor.js';

/**
 * Form class
 * @class Form
 * @extends PropertyList
 * @property {string} id - Form id
 */
var Form = /*#__PURE__*/function (_PropertyList) {
  _inheritsLoose(Form, _PropertyList);
  function Form(id) {
    // console.log('enchilada value FormPageContrastColor', FormPageContrastColor.getAll())
    return _PropertyList.call(this, {
      id: id,
      type: 'form',
      properties: [FormBlockBackgroundValue, FormBlockBorderRadius, FormBlockBorderStyle, FormBlockBorderType, FormBlockBorderValue, FormBlockBorderWidth, FormBlockShadowType, FormBlockShadowValue, FormPageFontBody, FormPageFontHeading, FormPageBackgroundValue, FormBlockBackgroundType, FormBlockShadowStyle, FormPageBackgroundType, FormPageContrastColor, FormBlockContrastColor, FormPageButtonContrastColor, FormBlockButtonContrastColor]
    }) || this;
  }
  return Form;
}(PropertyList);

export { Form as default };
//# sourceMappingURL=Form.js.map
